import { SET_APP_VERSION, SET_I18N_DATA, SET_APP_ID, SET_IS_LIVIN_ENABLED, SET_FEATURES, SET_GUEST_LOGIN_DATA, SET_SSP_DATA, SET_SETTINGS } from "../constants/constants";
import { SA_ADDRESS1, SA_ADDRESS2, SA_ADDRESS3, SA_ADDRESS4, SA_CLAIMS_EMAIL, SA_CLIENT_CARE_EMAIL, SA_LAT, SA_LONG, SA_SALES_EMAIL, SA_TEL, SA_KP_FSP } from "../constants/internationalization";
export const initialState = {
    buildVersion: '',
    reloadOnUnmount: true,
    lat: SA_LAT,
    long: SA_LONG,
    address1: SA_ADDRESS1,
    address2: SA_ADDRESS2,
    address3: SA_ADDRESS3,
    address4: SA_ADDRESS4,
    contactUs_tel: SA_TEL,
    clientcare_email: SA_CLIENT_CARE_EMAIL,
    claims_email: SA_CLAIMS_EMAIL,
    sales_email: SA_SALES_EMAIL,
    fsp_license: SA_KP_FSP,
    applicationId: {},
    useClaimHistoryV2: true,
    livinEnabled: false,
    drivableClaimsEnabled: false,
    drivableVapClaimsEnabled: false,
    selfInspectionEnabled: false,
    cellphoneClaimsEnabled: false,
    removeCoverEnabled: false,
    followUpEnabled: false,
    codeRedEnabled: false,
    salesWarrantyEnabled: false,
    agreedValueEnabled: false,
    salesBuildingAndContentEnabled: false,
    showLinkAuto: false,
    showSaleSelectAuto: false,
    sendRemovalEmail: false,
    paymentPortalOnly: false,
    portalRedirectUrl: "",
};
const sspReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_APP_VERSION:
            return {
                ...state,
                buildVersion: action.payload,
            }
        case SET_I18N_DATA:
            return {
                ...state,
                lat: ('lat' in action.payload) ? action.payload.lat : state.lat,
                long: ('long' in action.payload) ? action.payload.long : state.long,
                address1: ('address1' in action.payload) ? action.payload.address1 : state.address1,
                address2: ('address2' in action.payload) ? action.payload.address2 : state.address2,
                address3: ('address3' in action.payload) ? action.payload.address3 : state.address3,
                address4: ('address4' in action.payload) ? action.payload.address4 : state.address4,
                contactUs_tel: ('contactUs_tel' in action.payload) ? action.payload.contactUs_tel : state.contactUs_tel,
                clientcare_email: ('clientcare_email' in action.payload) ? action.payload.clientcare_email : state.clientcare_email,
                claims_email: ('claims_email' in action.payload) ? action.payload.claims_email : state.claims_email,
                sales_email: ('sales_email' in action.payload) ? action.payload.sales_email : state.sales_email,
                fsp_license: ('fsp_license' in action.payload) ? action.payload.fsp_license : state.fsp_license,
            }
        case SET_IS_LIVIN_ENABLED:
            return {
                ...state,
                livinEnabled: action.payload
            }
        case SET_FEATURES:
            return {
                ...state,
                drivableClaimsEnabled: ('DrivableClaims' in action.payload) ? action.payload.DrivableClaims : state.drivableClaimsEnabled,
                drivableVapClaimsEnabled: ('DrivableVapClaimsEnabled' in action.payload) ? action.payload.DrivableVapClaimsEnabled : state.drivableVapClaimsEnabled,
                selfInspectionEnabled: ('SelfInspection' in action.payload) ? action.payload.SelfInspection : state.selfInspectionEnabled,
                cellphoneClaimsEnabled: ('CellphoneClaims' in action.payload) ? action.payload.CellphoneClaims : state.cellphoneClaimsEnabled,
                removeCoverEnabled: ('RemoveCover' in action.payload) ? action.payload.RemoveCover : state.removeCoverEnabled,
                followUpEnabled: ('FollowUpQuestions' in action.payload) ? action.payload.FollowUpQuestions : state.followUpEnabled,
                codeRedEnabled: ('CodeRedEnabled' in action.payload) ? action.payload.CodeRedEnabled : state.codeRedEnabled,
                salesWarrantyEnabled: ('SalesWarrantyEnabled' in action.payload) ? action.payload.SalesWarrantyEnabled : state.salesWarrantyEnabled,
                agreedValueEnabled: ('AgreedValueEnabled' in action.payload) ? action.payload.AgreedValueEnabled : state.agreedValueEnabled,
                salesBuildingAndContentEnabled: ('SalesBuildingAndContentEnabled' in action.payload) ? action.payload.SalesBuildingAndContentEnabled : state.salesBuildingAndContentEnabled,
                sendRemovalEmail: ('SendRemovalEmail' in action.payload) ? action.payload.SendRemovalEmail : state.sendRemovalEmail,
            }
        case SET_SETTINGS:
            return {
                ...state,
                paymentPortalOnly: ('PaymentPortalOnly' in action.payload) ? action.payload.PaymentPortalOnly : state.paymentPortalOnly,
                portalRedirectUrl: ('PortalRedirectUrl' in action.payload) ? action.payload.PortalRedirectUrl : state.portalRedirectUrl,
            }
        case SET_APP_ID:
            return {
                ...state,
                applicationId: action.payload,
            }
        case SET_GUEST_LOGIN_DATA:
            return {
                ...state,
                showLinkAuto: ('showLinkAuto' in action.payload) ? action.payload.showLinkAuto : state.showLinkAuto,
                showSaleSelectAuto: ('showSaleSelectAuto' in action.payload) ? action.payload.showSaleSelectAuto : state.showSaleSelectAuto,
            }
        case SET_SSP_DATA:
            return {
                ...state,
                reloadOnUnmount: ('reloadOnUnmount' in action.payload) ? action.payload.reloadOnUnmount : state.reloadOnUnmount,
            }
        default:
            return state;
    }
}
export default sspReducer;